import CaretDown16 from '@carbon/icons-react/es/caret--down/16';
import TextScale16 from '@carbon/icons-react/es/text--scale/16';
import { Editor } from '@ckeditor/ckeditor5-core/src/editor';
import { Dropdown as AntDropdown } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { Menu } from 'components/atoms/dropdown';
import styles from './heading-dropdown.module.css';

interface Props {
  editor: Editor | null;
}
const Dropdown = styled(AntDropdown)`
  padding: 0 !important;
`;

export const HeadingDropdown: FC<Props> = ({ editor }: Props) => {
  const textConfig = [
    {
      model: 'paragraph',
      title: 'Normal Text',
      element: '<p>Normal Text</p>',
      command: 'paragraph',
    },
    {
      model: 'heading1',
      title: 'Heading 1',
      element: '<h3>Heading 1</h3>',
      command: 'heading',
    },
    {
      model: 'heading2',
      title: 'Heading 2',
      element: '<h4>Heading 2</h4>',
      command: 'heading',
    },
    {
      model: 'heading3',
      title: 'Heading 3',
      element: '<h5>Heading 3</h5>',
      command: 'heading',
    },
  ];

  const executes = (_editor, command, model) => {
    const cmdValue = command === 'paragraph' ? undefined : { value: model };

    _editor?.execute(command, cmdValue);
    _editor?.editing.view.focus();
  };

  const menu = (
    <Menu>
      {textConfig.map(({ model, command, element }) => (
        <Menu.Item key={model} onClick={() => executes(editor, command, model)}>
          <div
            // eslint-disable-next-line @typescript-eslint/naming-convention
            dangerouslySetInnerHTML={{ __html: element }}
            className={styles['dropdown-item']}
          />
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={menu} className={styles.dropdown}>
      <Button
        type="text"
        size="small"
        disabled
        icon={<CaretDown16 />}
        iconPlacement="right"
      >
        <TextScale16 />
      </Button>
    </Dropdown>
  );
};
